import { render, staticRenderFns } from "./OctAmountSelector.vue?vue&type=template&id=1f7a2fc3&scoped=true&"
import script from "./OctAmountSelector.vue?vue&type=script&lang=js&"
export * from "./OctAmountSelector.vue?vue&type=script&lang=js&"
import style0 from "./OctAmountSelector.vue?vue&type=style&index=0&id=1f7a2fc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a2fc3",
  null
  
)

export default component.exports